import React from "react";
import styled from "styled-components";
import media from "../../helpers/media";

export default () => (
  <Wrapper>
    <Content>
      <BrowserHeader>
        <Close></Close>
        <Min></Min>
        <Max></Max>
      </BrowserHeader>

      <Typing id="typing">
        Oops! It looks like you're lost.
        <br />
        Sorry about that.
        <br />
        Let me try and help.
        <br />
        Go back <Link href="https://resumo.in/">home</Link> and start over.
        <br />
      </Typing>
    </Content>
  </Wrapper>
);

const Wrapper = styled.div`
  background: #000;
  color: #fff;
  line-height: 1.5;
  height:100vh;
  @media ${media.tablet} {
    background-image: url(https://images.unsplash.com/photo-1542903660-eedba2cda473?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    min-height: 100vh;
  }
`;
const Content = styled.div`
  @media ${media.tablet} {
    width: 500px;
    height: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #333;
    padding: 45px 20px 20px;
    box-sizing: border-box;
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.5);
    border-radius: 5px 5px 0 0;
  }
`;
const BrowserHeader = styled.div`
  @media ${media.tablet} {
    background: #f9f9f3;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 5px;
    overflow: hidden;
    border-radius: 5px 5px 0 0;
  }
`;

const Button = styled.span`
  @media ${media.tablet} {
    display: inline-block;
    float: left;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
`;

const Close = styled(Button)`
  @media ${media.tablet} {
    background: #fc635d;
  }
`;

const Min = styled(Button)`
  @media ${media.tablet} {
    background: #fdbc40;
  }
`;

const Max = styled(Button)`
  @media ${media.tablet} {
    background: #34c84a;
  }
`;

const Typing = styled.div`
  overflow: hidden;
  white-space: nowrap;
  letter-spacing: 0.15em;
`;

const Link = styled.a`
  color: #fff;
  text-decoration: none;
  border-bottom: solid 2px;
`;
